import React from 'react';
import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import {Badge} from 'reactstrap';
import PropTypes from 'prop-types';

export const SortableColumnItem = ({id, name, onRemove, required = false}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: id,
    data: {
      id: id,
      name: name,
      required: required
    }
  });

  const style = {
    transition,
    transform: CSS.Transform.toString(transform),
    opacity: isDragging ? 0.5 : 1,
    position: 'relative',
    zIndex: isDragging ? 1 : 'auto',
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="d-flex justify-content-between align-items-center px-3 py-2"
    >
      <div className="d-flex align-items-center">
        <span
          className="fa fa-grip-lines me-2 drag-handle"
          {...attributes}
          {...listeners}
        ></span>
        <span>{name}</span>
        {required && (
          <Badge color="primary" pill className="ms-2">
            Required
          </Badge>
        )}
      </div>
      {!required ? (
        <span className="required-column-icon cursor-pointer" onClick={onRemove}>
          <i className="fa fa-times text-muted"></i>
        </span>

      ) : (
        <span className="required-column-icon">
          <i className="fa fa-lock text-muted" title="This column cannot be removed"></i>
        </span>
      )}
    </div>
  );
};

SortableColumnItem.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onRemove: PropTypes.func.isRequired,
  required: PropTypes.bool,
};
